/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'forward': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 8V4l8 8-8 8v-4H4V8h8z"/>'
  }
})
